import { render, staticRenderFns } from "./taskResponsibles.vue?vue&type=template&id=45708be7&"
import script from "./taskResponsibles.vue?vue&type=script&lang=js&"
export * from "./taskResponsibles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports